import { useState } from 'react';
import { unsubscribeNewsletter } from '../api/newsletter';

export function UnsubscribePage() {
  const [isSuccess, setIsSuccess] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  
  const [email, setEmail] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setErrorMsg('');
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setErrorMsg('*Please enter a valid email address.');
      return;
    }

    setIsLoading(true);
    try {
      await unsubscribeNewsletter(email);
      setIsSuccess(true);
    } catch (err) {
      setErrorMsg(err instanceof Error ? err.message : 'Unsubscription failed.');
    } finally {
      setIsLoading(false);
    }
  };

  const isSubmitDisabled = !email || isLoading;

  if (isSuccess) {
    return (
      <div className="main-container" id="unsubscription_confirm">
        <div className="main-container-top">
          <h2>Email Address Confirmation</h2>
          <p className="main-text">An unsubscription confirmation email has been sent. Please check your email.</p>
          <p className="note-text">*If the email address does not match our records, you may not receive the email.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="main-container" id="unsubscription_form">
      <div className="main-container-top">
        <h2>Newsletter Unsubscription Form</h2>
        <p className="main-text">If you would like to unsubscribe from the newsletter, please enter the email address already registered and click the &quot;Unsubscribe&quot; button.</p>
      </div>
      <form className="form-fields" onSubmit={handleSubmit}>
        <div className="email-input">
          <label htmlFor="unsubscribeEmail">email</label>
          <input 
            type="email" 
            id="unsubscribeEmail" 
            placeholder="Please input"
            value={email}
            onChange={(e) => { setEmail(e.target.value); setErrorMsg(''); }}
            required
          />
          {errorMsg && <p className="error-text">{errorMsg}</p>}
        </div>
        <button className="primary" type="submit" id="form-unsubscribe" disabled={isSubmitDisabled}>
          <span />
          <span>{isLoading ? 'Sending...' : 'Unsubscribe'}</span>
          <img src="/assets/arrow_right_white.svg" alt="" width="24" height="24" />
        </button>
      </form>
    </div>
  );
}
